import { Stack, Text, ButtonLink } from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import type { StoreProps } from 'src/store';

const NoListings = () => {
  const clientNumber = useSelector(
    ({ account }: StoreProps) => account.clientNumber,
  );
  const hasPaid = useSelector((store: StoreProps) => store.account.paid);

  const createAdLink = queryString.stringifyUrl({
    url: hasPaid
      ? getConfigValues().ADVERTISER_CENTRE_URL + Routes.CREATE_AD_URL
      : Routes.PACKAGES,
    query: hasPaid
      ? {
          ClientId: clientNumber.toString(),
        }
      : undefined,
  });

  return (
    <Stack space="medium" align="center">
      <LayoutBox maxWidth={600}>
        <Text align="center" size="large">
          Welcome to SEEK Business. Create an ad to showcase your business to
          Australia&apos;s largest buying audience.
        </Text>
      </LayoutBox>
      <LayoutBox width={200}>
        <ButtonLink href={createAdLink}>Create an ad</ButtonLink>
      </LayoutBox>
    </Stack>
  );
};

export default NoListings;
